export const GET_ALL_MUSICAS_EM_ESPERA = 'GET_ALL_MUSICAS_EM_ESPERA'
export const GET_MUSICA_EM_ESPERA_ESPECIFICA = 'GET_MUSICA_EM_ESPERA_ESPECIFICA'
